
import axios from 'axios';
import { BASE_URL } from "src/config/config";
import { toast } from 'react-toastify'

export const getCandidatesByBatchId = async (currentPage, limit, batchId) => {
    try {
      let response = await axios.get(`${BASE_URL}apiBatch/singleBatch/${batchId}`,{
        params: {
          page: currentPage,
          limit: limit
        }
      })
      if (response.status == '200') {
        return response.data;
      }
    } catch (error) {
      console.error('Error fetching records:', error);

    }
  }